import { DateTime } from 'luxon'

import type { AgeAssuranceHistory, AgeAssuranceSession } from '@/client/services/ageAssurance/types'

export default function getLatestAgeAssuranceSession(
  history: AgeAssuranceHistory
): AgeAssuranceSession | null {
  return (
    history
      .filter(session => session.nullifiedAt == null)
      .sort((a, b) => DateTime.fromISO(b.startedAt).diff(DateTime.fromISO(a.startedAt)).toMillis())
      .at(0) ?? null
  )
}
